import 'react-app-polyfill/ie11';
import  "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
// import ReactDOM from 'react-dom/client';
import App from './App';
// import {BrowserRouter} from 'react-router-dom'
import {HashRouter} from 'react-router-dom'


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <BrowserRouter>
//         <App />
//     </BrowserRouter>
// );


ReactDOM.render(
    <HashRouter>
        <App />
    </HashRouter>, 
    document.getElementById('root')
)